import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from './use-api-client.js';

// Monthly cost threshold of a server

export function useCostThreshold(serverId: string) {
  const api = useApiClient();
  return useQuery({ queryKey: ['cost-threshold', serverId], queryFn: () => api.costThreshold.get(serverId), refetchInterval: 3_600_000 });
}

export function useSetCostThreshold(serverId: string) {
  const api = useApiClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (monthlyUsd: number | null) => api.costThreshold.set(serverId, monthlyUsd),
    onSuccess: (status) => {
      qc.setQueryData(['cost-threshold', serverId], status);
      void qc.invalidateQueries({ queryKey: ['inbox', serverId] });
    },
  });
}
